/**
 * Created by kentalito on 2016-02-12.
 */

"use strict";

var StaffLedgerWorkReports = WorkReports.extend({
    reportsFilterKey: 'staffledger.filterParams',

    shareByEmail: function(emailAddress, message, shareInternalInfo, /*pdf,//*/ include) {
        var data = { to: emailAddress, message: message };
        if (shareInternalInfo) data.internal = true;
        //if (pdf) data.pdf = true;
        if (typeof include == 'object')
            data.include = include.join(',');
        else if (include)
            data.include = include;
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/share/email',
            type: 'POST',
            data: data
        }).success(function (data) {
            self.attributes.events.push({
                type: 'SHARE',
                comment: emailAddress,
                userId: Core.client.me.get('id'),
                eventTimeStamp: new Date().getTime(),
                internal: true
            });
        });

    },

});


var StaffLedgerRow = Backbone.Model.extend({
    workReports: StaffLedgerWorkReports,
    initialize: function(options){
        this.workReports = new StaffLedgerWorkReports();
        this.id = options.id;
        this.workDate = new Date(Formatting.datePart(options.workDate,true)).getTime();//options.workDate;
    },

    getWorkReports: function(){
        return workReports;
    },

    startTime: function(){
        var startTime = null;

        this.workReports.each(function(workReport){
            startTime = startTime == null || workReport.get('startTime') != null && workReport.get('startTime') < startTime ? workReport.get('startTime') : startTime;
        });
        return startTime;
    },

    endTime: function(){
        var lastEndTime = null;
        var maxStartTime = null;

        this.workReports.each(function(workReport){
            var startTime = workReport.get('startTime');
            var endTime = workReport.get('endTime');
            maxStartTime = maxStartTime == null || (startTime != null && startTime > maxStartTime) ? startTime : maxStartTime;
            lastEndTime = startTime == maxStartTime  ? endTime : lastEndTime;
        });
        return lastEndTime;
    },
    isEditing: function() {
        return this.workReports.filter(function(report){ return isNaN(report.id) || report.editing == true;}).length > 0;
    },
    workReportsForEditing: function() {
        return this.workReports.filter(function(report){ return isNaN(report.id)});
    }

});

var StaffLedgerCollection = Backbone.Collection.extend({
    model: StaffLedgerRow,
    initialize: function(models, options){

    },

    push: function(object, isNew){
        var targetObject = this.findWhere({userId: object.get('userId'), workDate: new Date(Formatting.datePart(object.get('workDate'),true)).getTime()});
        if (targetObject == undefined){
            targetObject = new StaffLedgerRow({userId: object.get('userId'), workDate: new Date(Formatting.datePart(object.get('workDate'),true)).getTime()});
            if (object.id == null)
                this.add(targetObject,{at:0})
            else
                this.models.push(targetObject);
        }
        //targetObject.editing = forEditing;
        targetObject.workReports.push(object);
    },

});
